import { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import Slider from "react-slick";

import CustomButton from "../../../common/CustomButton";
import CompanySignup from "../signup/CompanySignup";
import EmailVerify from "./components/EmailVerify";
import CodeVerify from "./components/CodeVerify";
import Logout from "../../../common/Logout";

import { GetCompanyProfile } from "../../../redux/v2/company/actions";

import "./style.css";

function CompanyUserVerification(props) {
    const navigate = useNavigate();
    const token = new URLSearchParams(window.location.search).get("token");

    const sliderRef = useRef(null);
    const [company, setCompany] = useState(null);
    const [page, setPage] = useState(0);
    const [userToken, setUserToken] = useState(null);
    const [userData, setUserData] = useState(null);
    const [email, setEmail] = useState("");

    useEffect(async () => {
        const comp = await props.GetCompanyProfile(token);

        setCompany(comp);
    }, []);

    const SlideTo = (p) => {
        sliderRef?.current?.slickGoTo(p);
    }

    const settings = {
        rows: 1,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        swipeToSlide: true,
        swipe: false,
        arrows: false,
        draggable: false,
        initialSlide: page,
        adaptiveHeight: true,
    };

    return (
        <>
            <Logout showLogo showLogout={false} />
            <div id="company-user-verification" className="content-area">

                <div id="company-user-verification-wrapper">
                    <Slider {...settings} ref={sliderRef}>
                        <div>
                            {/* <h3>WELCOME</h3> */}

                            <div id="cuv-logo-header" className="flex-c">
                                <div id="cuv-logo-wrapper">
                                    {
                                        company?.logo
                                            ? <img src={(process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV) + company?.logo} />
                                            : <Skeleton variant="rounded" width={"100%"} height={"100%"} />
                                    }
                                </div>
                            </div>

                            <div id="cuv-company-name">
                                {
                                    company?.name
                                        ? <h4>{company.name} has partnered with indi to keep you moving.</h4>
                                        : <Skeleton variant="rounded" width={400} height={40} />
                                }

                            </div>

                            <div id="cuv-action" className="flex-c">
                                <CustomButton onClick={() => {
                                    SlideTo(1);
                                }}>Verify Email</CustomButton>
                            </div>

                        </div>

                        <div id="cuv-email-verify-wrapper">
                            <EmailVerify setUserToken={setUserToken} setUserData={setUserData} SlideTo={SlideTo} setEmailToParent={setEmail} token={token} />
                        </div>

                        <div id="cuv-verfication-code">
                            {
                                (userToken && userData) && <>
                                    {
                                        !userData.password
                                            ? <CodeVerify SlideTo={SlideTo} email={email} userData={userData} />
                                            : <div id="cuv-with-password">
                                                <div>
                                                    <h4>Email already activated.</h4>
                                                    <div id="cuv-action-button-grp">
                                                        <CustomButton
                                                            onClick={() => {
                                                                navigate("/login");
                                                            }}
                                                        >
                                                            Login
                                                        </CustomButton>
                                                        <a target="_blank" href="https://apps.apple.com/us/app/indi-get-moving/id6444163742">
                                                            <img src="/assets/images/appstore.png" />
                                                        </a>

                                                        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.indimoves.indi">
                                                            <img src="/assets/images/googleplay.png" />
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                </>
                            }
                        </div>

                        <div id="company-signup-wrapped">
                            {
                                (userToken && userData) && <CompanySignup token={userToken} userData={{
                                    ...userData,
                                    name: company?.name,
                                    launchDate: company?.launchDate,
                                    logo: company?.logo,
                                    createdAt: company?.createdAt,
                                }} />
                            }
                        </div>
                    </Slider>
                </div>

            </div>

        </>
    );
}


const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    GetCompanyProfile,
})(CompanyUserVerification);
